import { type ResponsiveImageType, Image } from 'react-datocms';

import { CardImageWrapper } from './styles';

export const CardImage = (props: ResponsiveImageType) => {
  return (
    <CardImageWrapper>
      <Image data={props} layout="fill" objectPosition="center" />
    </CardImageWrapper>
  );
};
